import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import fetchJwks from '../runtime/fetch_jwks.js';
import { isCloudflareWorkers } from '../runtime/env.js';
import { JWKSInvalid, JWKSNoMatchingKey } from '../util/errors.js';
import { isJWKSLike, LocalJWKSet } from './local.js';
var RemoteJWKSet = /*#__PURE__*/function (_LocalJWKSet) {
  _inherits(RemoteJWKSet, _LocalJWKSet);
  var _super = _createSuper(RemoteJWKSet);
  function RemoteJWKSet(url, options) {
    var _this;
    _classCallCheck(this, RemoteJWKSet);
    _this = _super.call(this, {
      keys: []
    });
    _this._jwks = undefined;
    if (!(url instanceof URL)) {
      throw new TypeError('url must be an instance of URL');
    }
    _this._url = new URL(url.href);
    _this._options = {
      agent: options === null || options === void 0 ? void 0 : options.agent,
      headers: options === null || options === void 0 ? void 0 : options.headers
    };
    _this._timeoutDuration = typeof (options === null || options === void 0 ? void 0 : options.timeoutDuration) === 'number' ? options === null || options === void 0 ? void 0 : options.timeoutDuration : 5000;
    _this._cooldownDuration = typeof (options === null || options === void 0 ? void 0 : options.cooldownDuration) === 'number' ? options === null || options === void 0 ? void 0 : options.cooldownDuration : 30000;
    _this._cacheMaxAge = typeof (options === null || options === void 0 ? void 0 : options.cacheMaxAge) === 'number' ? options === null || options === void 0 ? void 0 : options.cacheMaxAge : 600000;
    return _this;
  }
  _createClass(RemoteJWKSet, [{
    key: "coolingDown",
    value: function coolingDown() {
      return typeof this._jwksTimestamp === 'number' ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
  }, {
    key: "fresh",
    value: function fresh() {
      return typeof this._jwksTimestamp === 'number' ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
  }, {
    key: "getKey",
    value: function () {
      var _getKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(protectedHeader, token) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this._jwks || !this.fresh())) {
                  _context.next = 3;
                  break;
                }
                _context.next = 3;
                return this.reload();
              case 3:
                _context.prev = 3;
                _context.next = 6;
                return _get(_getPrototypeOf(RemoteJWKSet.prototype), "getKey", this).call(this, protectedHeader, token);
              case 6:
                return _context.abrupt("return", _context.sent);
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                if (!(_context.t0 instanceof JWKSNoMatchingKey)) {
                  _context.next = 16;
                  break;
                }
                if (!(this.coolingDown() === false)) {
                  _context.next = 16;
                  break;
                }
                _context.next = 15;
                return this.reload();
              case 15:
                return _context.abrupt("return", _get(_getPrototypeOf(RemoteJWKSet.prototype), "getKey", this).call(this, protectedHeader, token));
              case 16:
                throw _context.t0;
              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));
      function getKey(_x, _x2) {
        return _getKey.apply(this, arguments);
      }
      return getKey;
    }()
  }, {
    key: "reload",
    value: function () {
      var _reload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._pendingFetch && isCloudflareWorkers())) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return", new Promise(function (resolve) {
                  var isDone = function isDone() {
                    if (_this2._pendingFetch === undefined) {
                      resolve();
                    } else {
                      setTimeout(isDone, 5);
                    }
                  };
                  isDone();
                }));
              case 2:
                if (!this._pendingFetch) {
                  this._pendingFetch = fetchJwks(this._url, this._timeoutDuration, this._options).then(function (json) {
                    if (!isJWKSLike(json)) {
                      throw new JWKSInvalid('JSON Web Key Set malformed');
                    }
                    _this2._jwks = {
                      keys: json.keys
                    };
                    _this2._jwksTimestamp = Date.now();
                    _this2._pendingFetch = undefined;
                  }).catch(function (err) {
                    _this2._pendingFetch = undefined;
                    throw err;
                  });
                }
                _context2.next = 5;
                return this._pendingFetch;
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function reload() {
        return _reload.apply(this, arguments);
      }
      return reload;
    }()
  }]);
  return RemoteJWKSet;
}(LocalJWKSet);
export function createRemoteJWKSet(url, options) {
  return RemoteJWKSet.prototype.getKey.bind(new RemoteJWKSet(url, options));
}